import Vue from 'vue'

export default {
  setMarkerLayersEmitterContainerPlatform(state, data) {
    state.markerLayersEmitterContainerPlatform = data
  },
  setMarkerLayersEmitter(state, data) {
    state.markerLayersEmitter = data
  },
  updateMarkerLayersMap(state, data) {
    state.markerLayersMap = Object.assign({}, state.markerLayersMap, data)
  },
  updateMarkerLayersPopupMap(state, data) {
    state.markerLayersMapPopup = Object.assign({}, state.markerLayersMapPopup, data)
  },
  setMarkerLayersMapUpdated(state, data) {
    state.markerLayersMapUpdated = data
  },
  setMarkerLayersBuilding(state, data) {
    state.markerLayersBuilding = data
  },
  setMarkerLayersBuildingEmitter(state, data) {
    state.markerLayersBuildingEmitter = data
  },
  setMarkerLayersContainerPlatform(state, data) {
    state.markerLayersContainerPlatform = data
  },
  setMarkerLayersContainers(state, data) {
    state.markerLayersContainers = data
  },
  setMarkerLayersContainer(state, data) {
    state.markerLayersContainer = data
  },
  setMarkerLayersEmitters(state, data) {
    state.markerLayersEmitters = data
  },
  setMarkerLayersEmitterCategories(state, data) {
    state.markerLayersEmitterCategories = data
  },
  setMarkerLayersContainerPlatforms(state, data) {
    state.markerLayersContainerPlatforms = data
  },
  setMarkerLayersContainerMaterials(state, data) {
    state.markerLayersContainerMaterials = data
  },
  setMarkerLayersContainerTypes(state, data) {
    state.markerLayersContainerTypes = data
  },
  setMarkerLayersContainerGraphics(state, data) {
    state.markerLayersContainerGraphics = data
  },
  setMarkerLayersToEdit(state, data) {
    state.markerLayersToEdit = data
  }
}



// WEBPACK FOOTER //
// ./src/store/markerLayers/mutations.js